document.addEventListener('DOMContentLoaded', () => {
	const cfLinks = document.querySelectorAll('a[href="#contact-popup"]')
	const popupForm = document.querySelector('.form-popup')
	const closePopup = popupForm.querySelector('button.close')

	cfLinks.forEach(link => {
		link.addEventListener('click', e => {
			e.preventDefault()
			popupForm.classList.add('active')
		})
	})

	popupForm.addEventListener('click', e => {
		if (!e.target.closest('.card')) {
			popupForm.classList.remove('active')
		}
	})

	closePopup.addEventListener('click', () => {
		popupForm.classList.remove('active')
	})
})
